import Omy from "../Omy";
import { OMY_SETTING, OmyConst } from "../OmyConst";

export default class ScaleManager extends PIXI.utils.EventEmitter {
    constructor(app) {
        super();
        this._app = app;

        this.C_FULL_CHANGE = "full_change";
        this.C_ORIENTATION = "orientation";

        this._gameWidth = Omy.WIDTH;
        this._gameHeight = Omy.HEIGHT;
        this._gameOrientation = this._gameWidth > this._gameHeight ? "landscape" : "portrait";
        this._gameLandscapeScreenRatio = this._gameWidth / this._gameHeight;
        this._gamePortraitScreenRatio = this._gameHeight / this._gameWidth;

        this._minWidth = 0;
        this._minHeight = 0;

        this._maxWidth = Number.MAX_VALUE;
        this._maxHeight = Number.MAX_VALUE;
        this._scaleMode = OmyConst.SCALE_EXACT_FIT;

        this._isFullScreen = false;
        this._incorrectOrientation = false;
        this._customResize = false;
        this.forceOrientation();

        this._screenRatio = this._gameWidth / this._gameHeight;

        window.addEventListener("resize", this.resize.bind(this), false);
        this.resize();

        if (PIXI.utils.isMobile.apple.device) {
            if (OMY_SETTING.CHECK_IOS_FULLSCREEN) {
                let isMobileSafari = Omy.browser.mobileSafari || (Omy.browser.safari && !Omy.isDesktop);
                if (isMobileSafari && !Omy.browser.chrome && !/CriOS/.test(navigator.userAgent)) {
                    this._isFullScreen = this._checkIosFull();
                    Omy.addUpdater(this._updateTick, this);
                } else {
                    this._isFullScreen = true;
                }
            } else {
                this._isFullScreen = true;
            }
        } else {
            //called when an event goes full screen and vice-versa.
            document.addEventListener("fullscreenchange", this._screenChangeFull.bind(this));
            document.addEventListener("webkitfullscreenchange", this._screenChangeFull.bind(this));
            document.addEventListener("mozfullscreenchange", this._screenChangeFull.bind(this));
            document.addEventListener("MSFullscreenChange", this._screenChangeFull.bind(this));

            //called when requestFullscreen(); fails. it may fail if iframe don't have allowfullscreen attribute enabled or for something else.
            document.addEventListener("fullscreenerror", function() {
                console.log("Full screen failed");
            });
            document.addEventListener("webkitfullscreenerror", function() {
                console.log("Full screen failed");
            });
            document.addEventListener("mozfullscreenerror", function() {
                console.log("Full screen failed");
            });
            document.addEventListener("MSFullscreenError", function() {
                console.log("Full screen failed");
            });
            this._isFullScreen = (!("fullscreenEnabled" in document || "webkitFullscreenEnabled" in document || "mozFullScreenEnabled" in document || "msFullscreenEnabled" in document));
        }
    }

    /** @public */
    newResizeHandler() {
        this._customResize = true;
    }

    /**     * @public     */
    delayResize() {
        this.resize(null, true);
    }

    resize(first, isNow = false) {
        if (!Omy.isDesktop) {
            if (!isNow) {
                if (this._delayTimer) {
                    this._delayTimer.destroy();
                }
                this._delayTimer = Omy.add.timer(0.1, this.delayResize, this);
                return;
            }
        }

        this._delayTimer = null;

        let newWidth;
        let newHeight;

        this._isScreenPortrait = window.innerHeight >= window.innerWidth;
        this._isScreenLandscape = !this._isScreenPortrait;

        let screenWidth = Math.max(Math.min(window.innerWidth, this._maxWidth), this._minWidth);
        let screenHeight = Math.max(Math.min(window.innerHeight, this._maxHeight), this._minHeight);

        switch (this._scaleMode) {
            case OmyConst.SCALE_EXACT_FIT: {
                if (screenWidth / screenHeight >= this._screenRatio) {
                    newWidth = screenHeight * this._screenRatio;
                    newHeight = screenHeight;
                } else {
                    newWidth = screenWidth;
                    newHeight = screenWidth / this._screenRatio;
                }
                break;
            }
            case OmyConst.SCALE_SHOW_ALL: {
                newWidth = screenWidth;
                newHeight = screenHeight;
                break;
            }
        }
        if (!this._customResize) {
            // Omy.warn(newWidth, newHeight);
            this._app.renderer.view.style.width = newWidth + "px";
            this._app.renderer.view.style.height = newHeight + "px";
            // this._app.renderer.resize(newWidth, newHeight);
            // Omy.warn(this._app.screen.width, this._app.screen.height);
        }

        if (this._onlyLandscape) {
            if (this.isScreenLandscape && this._incorrectOrientation) {
                this._incorrectOrientation = false;
                this.emit(this.C_ORIENTATION);
            } else if (!this.isScreenLandscape && !this._incorrectOrientation) {
                this._incorrectOrientation = true;
                this.emit(this.C_ORIENTATION);
            }
        } else if (this._onlyPortrait) {
            if (this.isScreenPortrait && this._incorrectOrientation) {
                this._incorrectOrientation = false;
                this.emit(this.C_ORIENTATION);
            } else if (!this.isScreenPortrait && !this._incorrectOrientation) {
                this._incorrectOrientation = true;
                this.emit(this.C_ORIENTATION);
            }
        } else {
            this.emit(this.C_ORIENTATION);
        }
    }

    /**     * @public     */
    startFullScreen(container) {
        if (!this._isFullScreen) {
            // check if user allows full screen of elements. This can be enabled or disabled in browser config. By default its enabled.
            //its also used to check if browser supports full screen api.
            this._isFullScreen = true;
            this.emit(this.C_FULL_CHANGE);
            if ("fullscreenEnabled" in document || "webkitFullscreenEnabled" in document || "mozFullScreenEnabled" in document || "msFullscreenEnabled" in document) {
                if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled) {
                    console.log("User allows fullscreen");

                    // let element = document.getElementById("orientation");
                    let element = container || document.documentElement;
                    //requestFullscreen is used to display an element in full screen mode.
                    if ("requestFullscreen" in element) {
                        element.requestFullscreen();
                    } else if ("webkitRequestFullscreen" in element) {
                        element.webkitRequestFullscreen();
                    } else if ("mozRequestFullScreen" in element) {
                        element.mozRequestFullScreen();
                    } else if ("msRequestFullscreen" in element) {
                        element.msRequestFullscreen();
                    }

                }
            } else {
                console.log("User doesn't allow full screen");
            }
            // if(document.documentElement.requestFullscreen) {
            //     document.documentElement.requestFullscreen();
            // } else if(document.documentElement.mozRequestFullScreen) {
            //     document.documentElement.mozRequestFullScreen();
            // } else if(document.documentElement.webkitRequestFullscreen) {
            //     document.documentElement.webkitRequestFullscreen();
            // } else if(document.documentElement.msRequestFullscreen) {
            //     document.documentElement.msRequestFullscreen();
            // }
        }
    }

    /**     * @public     */
    stopFullScreen() {
        if (this._isFullScreen) {
            this._isFullScreen = false;
            this.emit(this.C_FULL_CHANGE);
            // exitFullscreen us used to exit full screen manually
            if (document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement) {
                if ("exitFullscreen" in document) {
                    document.exitFullscreen();
                } else if ("webkitExitFullscreen" in document) {
                    document.webkitExitFullscreen();
                } else if ("mozCancelFullScreen" in document) {
                    document.mozCancelFullScreen();
                } else if ("msExitFullscreen" in document) {
                    document.msExitFullscreen();
                }
            }
        }

    }

    /**     * @private     */
    _screenChangeFull() {
        //fullscreenElement is assigned to html element if any element is in full screen mode.
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            if (!this._isFullScreen) {
                console.log("auto allows fullscreen");
                this._isFullScreen = true;
                this.emit(this.C_FULL_CHANGE);
            }
        } else {
            this.stopFullScreen();
        }
    }

    addFullChange(func, context, once = false) {
        if (once)
            this.once(this.C_FULL_CHANGE, func, context);
        else
            this.on(this.C_FULL_CHANGE, func, context);
    }

    removeFullChange(func, context) {
        this.removeListener(this.C_FULL_CHANGE, func, context);
    }

    _checkIosFull() {
        let checkValue = (window.screen.height < window.screen.width) ? window.screen.height : window.screen.width;
        let iPad = (checkValue === 768);
        let iPadPro = (checkValue === 1024);
        let fullScreen = (window.innerHeight === $(window).height()); // eslint-disable-line
        if (iPad) fullScreen = true;
        if (iPadPro) fullScreen = true;
        return fullScreen;
    }

    /**     * @private     */
    _updateTick() {
        // if (!AntG.GF.scale.incorrectOrientation) {
        if (this._checkIosFull()) {
            if (!this._isFullScreen) {
                this._isFullScreen = true;
                this.emit(this.C_FULL_CHANGE);
            }
        } else {
            if (this._isFullScreen) {
                this._isFullScreen = false;
                this.emit(this.C_FULL_CHANGE);
            }
        }
        // }
    }

    /**     * @public     */
    forceOrientation(onlyLandscape = false, onlyPortrait = false) {
        this._onlyLandscape = onlyLandscape;
        this._onlyPortrait = onlyPortrait;

        if (this._onlyLandscape) {
            if (this.isScreenLandscape && this._incorrectOrientation) {
                this._incorrectOrientation = false;
                this.emit(this.C_ORIENTATION);
            } else if (!this.isScreenLandscape && !this._incorrectOrientation) {
                this._incorrectOrientation = true;
                this.emit(this.C_ORIENTATION);
            }
        } else if (this._onlyPortrait) {
            if (this.isScreenPortrait && this._incorrectOrientation) {
                this._incorrectOrientation = false;
                this.emit(this.C_ORIENTATION);
            } else if (!this.isScreenPortrait && !this._incorrectOrientation) {
                this._incorrectOrientation = true;
                this.emit(this.C_ORIENTATION);
            }
        }
    }

    addIncorrectOrientation(func, context, once = false) {
        if (once)
            this.once(this.C_ORIENTATION, func, context);
        else
            this.on(this.C_ORIENTATION, func, context);
    }

    removeIncorrectOrientation(func, context) {
        this.removeListener(this.C_ORIENTATION, func, context);
    }

    get gameWidth() {
        return this._gameWidth;
    }

    get gameHeight() {
        return this._gameHeight;
    }

    get gameOrientation() {
        return this._gameOrientation;
    }

    get gameLandscapeScreenRatio() {
        return this._gameLandscapeScreenRatio;
    }

    get gamePortraitScreenRatio() {
        return this._gamePortraitScreenRatio;
    }

    get screenRatio() {
        return this._screenRatio;
    }

    set screenRatio(value) {
        this._screenRatio = value;
    }

    get isScreenPortrait() {
        return this._isScreenPortrait;
    }

    get isScreenLandscape() {
        return this._isScreenLandscape;
    }

    set minWidth(value) {
        this._minWidth = value;
    }

    set minHeight(value) {
        this._minHeight = value;
    }

    set maxWidth(value) {
        this._maxWidth = value;
    }

    set maxHeight(value) {
        this._maxHeight = value;
    }

    set scaleMode(value) {
        this._scaleMode = value;
        this.resize();
    }

    get isFullScreen() {
        return this._isFullScreen;
    }

    get incorrectOrientation() {
        return this._incorrectOrientation;
    }
}
